import { Vlan } from './vlan';
import { Asignacion } from './asignacion';

export class DireccionIp {
  idDireccionIp: number;
  direccion: string;
  indicadorDisponible: boolean;
  primerOctecto: number;
  segundoOcteto: number;
  tercerOcteto:number;
  cuartoOcteto: number;
  vlan: Vlan;
  asignaciones: Asignacion;
  nombreDispositivo:string;

}



// WEBPACK FOOTER //
// ./src/app/shared/models/direccion-ip.ts